module.exports = __webpack_public_path__ + "static/media/pin-icon.b12dcedd.svg";